import { render } from "./ExamDownloadOffcanvas.vue?vue&type=template&id=2bdc6040&scoped=true"
import script from "./ExamDownloadOffcanvas.vue?vue&type=script&lang=js"
export * from "./ExamDownloadOffcanvas.vue?vue&type=script&lang=js"

import "./ExamDownloadOffcanvas.vue?vue&type=style&index=0&id=2bdc6040&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bdc6040"]])

export default __exports__